(function () {
  var PIXEL_ID = '872912193874554';
  var fired = false;

  function getConsentState() {
    if (navigator.globalPrivacyControl) return 'block';

    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;

    var c = cp.currentVisitorConsent();

    // No cookie banner interaction yet — don't track (CIPA)
    if (!c.marketing || c.marketing === '') return 'block';

    // Declined cookies — don't track
    if (c.marketing === 'no') return 'block';

    // Accepted cookies but opted out of data sale — track with LDU (CCPA)
    if (c.sale_of_data === 'no' || c.saleOfData === 'no') return 'limit';

    // Accepted cookies, no data sale opt-out — track normally
    return 'allow';
  }

  function firePixel() {
    if (fired) return;
    var state = getConsentState();
    if (!state || state === 'block') return;
    fired = true;

    // Load Meta Pixel base code
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    if (state === 'limit') {
      fbq('dataProcessingOptions', ['LDU'], 0, 0);
    } else {
      fbq('dataProcessingOptions', []);
    }
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }

  // Try to fire immediately if consent is already determined
  if (getConsentState() !== null) {
    firePixel();
  } else {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (getConsentState() !== null || attempts >= 30) {
        clearInterval(poll);
        firePixel();
      }
    }, 100);
  }

  // Fire or update when user interacts with cookie banner
  document.addEventListener('visitorConsentCollected', function () {
    if (!fired) {
      firePixel();
      return;
    }
    var state = getConsentState();
    if (state === 'limit') {
      fbq('dataProcessingOptions', ['LDU'], 0, 0);
    } else if (state === 'allow') {
      fbq('dataProcessingOptions', []);
    }
  });
})();
